<template>
  <main class="bg_gray">
    <div class="container-fluid">
      <div class="dash_header">
        <h1
          v-if="activeWebsite"
          class="heading font_bold"
        >
          <img :src="logoUrl">
          {{ activeWebsite.simple_url.slice(0, 1).toUpperCase() + activeWebsite.simple_url.slice(1) }} Dashboard
        </h1>
      </div>

      <gridstack-container />
    </div>
  </main>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import GridstackContainer from './components/GridstackContainer.vue'

export default {
  components: {
    GridstackContainer,
  },
  props: {
    uuid: {
      type: String,
      required: true,
    },
    logoUrl: {
      type: String,
      default: null,
    }
  },
  computed: {
    ...mapState('dashboard', ['activeWebsite'])
  },
  watch: {
    activeWebsite: {
      handler() {
        this.getTrafficData(this.activeWebsite.id)
      },
    },
  },
  mounted() {
    this.setPreview(true);
    this.getActiveWebsiteUUID(this.uuid).then(() => {
      this.getCountryFlags();
      this.getLayout();
      this.getCustomWidgets();
      this.getGMBLocations();
    });
  },
  methods: {
    ...mapMutations({
      setPreview: 'dashboard/setPreview',
    }),
    ...mapActions({
      getActiveWebsiteUUID: 'dashboard/getActiveWebsiteUUID',
      getCountryFlags: 'dashboard/getCountryFlags',
      getLayout: 'dashboard/getLayout',
      getCustomWidgets: 'dashboard/getCustomWidgets',
      getTrafficData: 'dashboard/getTrafficData',
      getGMBLocations: 'dashboard/getGMBLocations',
    }),
  },
}
</script>

<style scoped>
.dash_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  background: #f4f4f4;
  margin: 0;
}

.dash_header .heading {
  line-height: 1.25;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 2.5rem;
  margin: 0;
  display: flex;
  align-items: center;
}

.dash_header .heading img {
  height: 2.5rem;
  margin-right: 1rem;
}

.dash_toolbar {
  margin-bottom: 1rem;
}

.dash_toolbar button {
  margin: 0;
}

.settings_menu {
  margin: 0;
}

.settings_menu span {
  display: flex;
  align-items: center;
}

.select_dropdown {
  right: 5px;
  margin: 10px;
  z-index: 101;
  position: absolute;
  width: 190px;
  padding: 1rem;
  background-color: white;
  border: 1px solid #C7C4C1;
  border-radius: .75rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  list-style: none;
}

.select_dropdown li {
  padding: .25rem 0;
}

.select_dropdown li a {
  display: block;
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.1px;
  border-radius: 0.5rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.select_dropdown li a:hover {
  background-color: #FFEEEA;
}

.select_dropdown li hr {
  margin: 0.5rem 0;
}

.select_dropdown li a i,
.select_dropdown li a svg {
  margin-right: 0.5rem;
}

.select_dropdown li a span i {
  margin-right: 0;
}

.select_dropdown li a span {
  color: var(--primary-font-color);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.editing_layout {
  background: red;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  position: sticky;
  top: 65px;
  z-index: 11;
}

.editing_layout button {
  margin: 0;
  margin-left: 0.5rem;
}
</style>
